module.exports = __webpack_public_path__ + "static/media/8.d64b6e86.jpg";